//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

//algolia full text search
import { algolia } from 'assets/algolia';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomSelect from "components/Select/Select.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FileUpload from "components/FileUpload/FileUpload.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "components/CustomButtons/Button.jsx";
import PhotoCard from "components/PhotoCard/PhotoCard.jsx";
import PhotoUpload from "components/PhotoUpload/PhotoUpload.jsx";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import Money from "@material-ui/icons/AttachMoney"
import Photos from "@material-ui/icons/PhotoCameraOutlined";
import Attachment from "@material-ui/icons/AttachFile";
import Code from "@material-ui/icons/Code";

//draft html editor
import ContentEditor from "components/ContentEditor/ContentEditor.jsx";

//unique id generator
const uuidv4 = require('uuid/v4');

function Transition(props) {
  return <Slide direction="down" {...props} />;
}
  
  class ProductEditor extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        product: {
          ProductName: "", 
          BriefDescription: "", 
          CategoryID:"",
          Cost: 0,
          ListPrice: 0,
          sku: "",
          Photos: [],
          IsVisible: false
        },
        categories: props.categories,
        photos:[],
        attachments:[],
        uploadControls:[uuidv4()]
      };

      this.saveProduct = this.saveProduct.bind(this);
      this.updateProduct = this.updateProduct.bind(this);

      this.addPhoto = this.addPhoto.bind(this);
      this.deletePhoto = this.deletePhoto.bind(this);
      this.updatePhoto = this.updatePhoto.bind(this);
      this.makeCoverPhoto = this.makeCoverPhoto.bind(this);
      this.makeThumbPhoto = this.makeThumbPhoto.bind(this);

      this.fileUploaded = this.fileUploaded.bind(this);
    }

    handleClickOpen(modal) {
    
      if(this.props.product.CategoryID) {
        
          var product = this.props.product;

          if(!product.ListPrice)
            product.ListPrice = 0.00;
          if(!product.Cost)
            product.Cost = 0.00;
          
          if(!product.Photos) 
            product.Photos = [];
          if(!product.Attachments)
            product.Attachments = [];

          if(!product.IsVisible)
            product.IsVisible = false;

          this.setState({product: product, photos: product.Photos, attachments: product.Attachments}, () => {
            
            var x = [];
            x[modal] = true;
            this.setState(x);
          });
        
      } else {
          var x = [];
          x[modal] = true;
          this.setState(x);
      }
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    chooseCategory(value) {
      this.updateProduct("CategoryID",value);
    }

    updateProduct(property, value) {
      var obj = this.state.product;
      obj[property] = value;
      this.setState({product: obj});
    }

    saveProduct() {

      var product = this.state.product;
      product.Photos = this.state.photos;
      product.Attachments = this.state.attachments;
      
      db.updateProduct(product.id, product).then(doc => {
        
        this.props.onChange();

        console.log('product:');
          console.log(product);

        if(!product.id) { // i.e. if it's new

          product.id = doc.id;
          
          // update search index
          algolia.upsertProduct(product);

          // reset to blank
          this.setState({product:{
            sku:"",
            ProductName: "",
            BriefDescription: "",
            Cost: 0.00,
            ListPrice: 0.00,
            Photos: [],
            Attachments: []
          }, photos:[], attachments:[]});

        } else { // i.e. an existing obj

          // update search index
          algolia.upsertProduct(product);
        }
      });
    }

    addPhoto(id, url) {

      var photos = this.state.photos;
      var photo = { ID: id, Name: "New Photo", Description: "description", URL: url, isCover: false, isThumb: false};
      photos.push(photo);
      this.setState({photos:photos}, () => {
        this.setState({ uploadControls : [uuidv4()] });
      });
    }

    updatePhoto(photo) {
      var photos = this.state.photos;
      
      for(var i = 0; i < photos.length; i++) {
        if(photos[i].ID === photo.ID) {
          photos[i] = photo;
          break;
        }
      }
    }

    deletePhoto(photo) {
      var photos = this.state.photos;

      for(var i = 0; i < photos.length; i++) {
        if(photos[i].ID === photo.ID) {
          photos.splice(i,1);
          break;
        }
      }

      this.setState({photos:[]}, () => { // reset first necessary, seems like a bug
        this.setState({photos:photos}, () => {
          
        });
      });
    }

    makeCoverPhoto(photo) {
      var photos = this.state.photos;
      
      for(var i = 0; i < photos.length; i++) {
        if(photos[i].ID === photo.ID) {
          photos[i].isCover = true;
        } else {
          photos[i].isCover = false;
        }
      }
    }

    makeThumbPhoto(photo) {
      var photos = this.state.photos;
      
      for(var i = 0; i < photos.length; i++) {
        if(photos[i].ID === photo.ID) {
          photos[i].isThumb = true;
        } else {
          photos[i].isThumb = false;
        }
      }
    }

    fileUploaded(url) {
      var attachments = this.state.attachments;
      attachments.push( { Name:"New Attachment", URL: url } );
      this.setState({attachments: attachments });
    }

    updateAttachment(attachment, property, value) {
      var attachments = this.state.attachments;
  
      for(var i = 0; i < attachments.length; i++) {
        if(attachments[i].URL === attachment.URL) {
          attachments[i][property] = value;
          break;
        }
      }
      this.setState({attachments: attachments });
    }

    deleteAttachment(attachment) {
      var attachments = this.state.attachments;
      for(var i = 0; i < attachments.length; i++) {
        if(attachments[i].URL === attachment.URL) {
          attachments.splice(i,1);
          //todo, delete file from storage
        }
      }
      this.setState({attachments: attachments });
    }

    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton aria-label="Edit" onClick={() => this.handleClickOpen("modal")}>
            <Edit className={ classes.tableActionButtonIcon + " " + classes.edit } />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            maxWidth="md"
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Product</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: ShoppingCart,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={9}>
                            <CustomInput
                              labelText="Name"
                              value={this.state.product.ProductName}
                              inputProps={{
                                  placeholder: "Product Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateProduct("ProductName", e.target.value)}
                            />
                          </GridItem>

                          <GridItem xs={12} sm={12} md={3}>
                            <CustomInput
                              labelText="SKU"
                              value={this.state.product.sku}
                              inputProps={{
                                  placeholder: "SKU"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateProduct("sku", e.target.value)}
                            />
                          </GridItem>

                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              labelText="Description"
                              value={this.state.product.BriefDescription}
                              inputProps={{
                                  placeholder: "Description"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateProduct("BriefDescription", e.target.value)}
                            />
                          </GridItem>

                          <GridItem xs={12} sm={12} md={4}>
                            <CustomSelect
                              labelText="Category"
                              inputProps={{ placeholder: "Category" }}
                              formControlProps={{ fullWidth: true }}
                              onChange={(e) => this.chooseCategory(e.target.value)}
                              options={[
                                {key:"1",label:"Shirts"},
                                {key:"2",label:"Journals"},
                                {key:"3",label:"Posters"},
                                ]
                            }
                              value={this.state.product.CategoryID}
                            />
                          </GridItem>
                         
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomInput
                              labelText="Cost"
                              value={this.state.product.Cost}
                              inputProps={{
                                  placeholder: "Cost",
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Money />
                                    </InputAdornment>
                                  )
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateProduct("Cost", e.target.value)}
                            />
                          </GridItem>
                          
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomInput
                              labelText="List Price"
                              value={this.state.product.ListPrice}
                              inputProps={{
                                  placeholder: "List Price",
                                  endAdornment: (
                                    <InputAdornment position="end" color="success">
                                      <Money />
                                    </InputAdornment>
                                  )
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateProduct("ListPrice", e.target.value)}
                            />
                          </GridItem>
                          
                        </GridContainer>
                    )
                  },
                  {
                    tabName: "Photos",
                    tabIcon: Photos,
                    tabContent: (

                      <GridContainer direction="row" style={{minWidth:"800px", minHeight:"200px"}}>
                        <GridItem xs={12} style={{height:"54px"}}>
                          {this.state.uploadControls.map((controlID) => (
                            <PhotoUpload onUploadSuccess={this.addPhoto} key={controlID} />
                          ))}
                          
                        </GridItem>
                          {this.state.photos.map((photo,index) => (
                              <PhotoCard key={index} photo={photo} 
                                onPhotoUpdated={this.updatePhoto} onPhotoMakeCover={this.makeCoverPhoto} 
                                onPhotoMakeThumb={this.makeThumbPhoto} onPhotoDelete={this.deletePhoto} />
                          ))}
                        </GridContainer>
                    )
                  },
                  {
                    tabName:"HTML",
                    tabIcon: Code,
                    tabContent: (
                      <GridContainer style={{minHeight:"369px"}}>
                        <ContentEditor 
                          value={this.state.product.Content}
                          onChange={(e) => this.updateProduct("Content", e)}
                        />
                      </GridContainer>
                    )
                  },
                  {
                    tabName: "Attachments",
                    tabIcon: Attachment,
                    tabContent: (

                      <GridContainer direction="row" style={{minWidth:"800px", minHeight:"200px"}}>
                        <FileUpload fileUploaded={this.fileUploaded} />
                        <Table>
                          <TableBody>
                          {this.state.attachments.map((attachment,index) => ( 
                            <TableRow key={index}>
                              <TableCell>
                                <input type="text" value={attachment.Name} placeholder="name" 
                                  onChange={(e) => this.updateAttachment(attachment, "Name", e.target.value)} 
                                  style={{borderStyle:"none", backgroundColor:"#efefef", padding:"6px", height:"21px", borderRadius:"6px", fontSize:"12px", width:"100%"}} /> 
                              </TableCell>
                              <TableCell>
                                <a href={attachment.URL} target="_new">Download</a>
                              </TableCell>
                              <TableCell className={classes.tableActions} style={{padding:"6px", width:"23px"}}> 
                                <Tooltip id="tooltip-top-start" title="Delete Attachment" placement="top" classes={{ tooltip: classes.tooltip }} >
                                  <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this attachment? This action cannot be undone." confirmed={() => this.deleteAttachment(attachment)} />
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                          </TableBody>
                        </Table>
                      </GridContainer>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
                <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.product.IsVisible}
                        onChange={(e) => this.updateProduct("IsVisible", e.target.checked)}
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{ label: classes.label }}
                    label="Visible"
                />
                <Button onClick={() => this.handleClose("modal")} >
                  Cancel
                </Button>
                &nbsp;
                <Button
                  onClick={() => {
                      this.saveProduct();
                      this.handleClose("modal");
                    }}
                  color="success">
                  Save
                </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

ProductEditor = connect(mapStateToProps)(ProductEditor);
export default withStyles(modalStyle)(ProductEditor);


// WEBPACK FOOTER //
// ./src/components/ProductEditor/ProductEditor.jsx